import App from "../../App";

const delimiters = require('handlebars-delimiters');
const Handlebars = require('handlebars');
const moment = require('moment');
require('moment/locale/de');
delimiters(Handlebars, ['<%', '%>']);

Handlebars.registerHelper("debug", function (optionalValue) {
  console.log("\nCurrent Context");
  console.log("====================");
  console.log(this);

  if (arguments.length > 1) {
    console.log("Value");
    console.log("====================");
    console.log(optionalValue);
  }
});

Handlebars.registerHelper('first', function (context, block) {
  return block(context[0]);
});

Handlebars.registerHelper('slice', function (context, block) {
  let ret = "",
    offset = parseInt(block.hash.offset) || 0,
    limit = parseInt(block.hash.limit) || 5,
    i = (offset < context.length) ? offset : 0,
    j = ((limit + offset) < context.length) ? (limit + offset) : context.length;

  for (i, j; i < j; i++) {
    ret += block(context[i]);
  }
  return ret;
});

Handlebars.registerHelper('toSentence', function (context, block) {
  let ret = "";
  for (let i = 0, j = context.length; i < j; i++) {
    ret = ret + block(context[i]);
    if (i < j - 1) {
      ret = ret + ", ";
    }
  }
  return ret;
});

Handlebars.registerHelper('dateFormat', function (context, block) {
  if (moment && context && moment(context).isValid()) {
    let f = block.hash.format || "MMM Do, YYYY";
    return moment(context).format(f);
  } else {
    return context;
  }
});

Handlebars.registerHelper('dateHuman', function (context, block) {
  if (moment && context && moment(context).isValid()) {
    let f = block.hash.format || "YYYY-MM-DD HH:mm:ss";
    return moment(App.adjustTime(new Date(context)), f).fromNow();
  } else {
    return context;
  }
});

Handlebars.registerHelper('ifEquals', function (v1, v2, options) {
  if (v1 == v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

module.exports = Handlebars;
